import React from 'react';

import {ResponsiveElementGroup} from 'src/components/responsive-element-group';
import {CheckboxSkeleton, FormItemSkeleton, SkeletonItem} from 'src/components/skeleton';

import {Group} from '@pb/kit-component-group';

export const EditSectionSkeleton = () => (
    <Group direction="v" alignItems="start">
        <FormItemSkeleton labelWidth={85}>
            <SkeletonItem width={550} height={30}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={85}>
            <Group>
                <CheckboxSkeleton labelWidth={125}/>
                <CheckboxSkeleton labelWidth={140}/>
            </Group>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={85}>
            <SkeletonItem width={550} height={30}/>
        </FormItemSkeleton>
        <FormItemSkeleton labelWidth={56}>
            <ResponsiveElementGroup>
                {new Array(14).fill(null).map((_, index) => (
                    <SkeletonItem key={index} width={25} height={25}/>
                ))}
            </ResponsiveElementGroup>
        </FormItemSkeleton>
    </Group>
);
